package com.flowyride.core.map

import androidx.compose.ui.unit.DpOffset
import com.flowyride.core.domain.model.GeoPoint

/**
 * @param screenOffset Where the click happened, from the top-left corner of the map (to anchor a popup).
 */
data class MapClick(
    val point: GeoPoint,
    val screenOffset: DpOffset,
)

/** The map repeats horizontally: longitudes may come back outside ±180°. */
internal fun normalizeLongitude(longitude: Double): Double = ((longitude + 540.0) % 360.0) - 180.0
